import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "inline-block mb-4 md:mb-6" }
const _hoisted_2 = { class: "flex items-start" }
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = {
  key: 0,
  class: "ml-4 my-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Who it is about", -1)
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, "Challenge area", -1)
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h4", null, "Challenge situation", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", null, "Actions taken", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", null, "Outcome", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h4", null, "Would you do anything differently?", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h4", null, "Tips", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_AppButtonRouterLink = _resolveComponent("AppButtonRouterLink")!
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_AddIcon = _resolveComponent("AddIcon")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ContentBlockDivider = _resolveComponent("ContentBlockDivider")!
  const _component_Markdown = _resolveComponent("Markdown")!
  const _component_ContentBlock = _resolveComponent("ContentBlock")!
  const _component_AppContent = _resolveComponent("AppContent")!
  const _component_CreateIdea = _resolveComponent("CreateIdea")!
  const _component_ModalContent = _resolveComponent("ModalContent")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppContent, null, {
      default: _withCtx(() => [
        _createVNode(_component_ContentBlock, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.backLink)
                ? (_openBlock(), _createBlock(_component_AppButtonRouterLink, {
                    key: 0,
                    type: "outline",
                    to: _ctx.backLink
                  }, {
                    iconBefore: _withCtx(() => [
                      _createVNode(_component_ArrowRightIcon, { class: "mr-2 stroke-current stroke-2 rotate-180" })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" Back ")
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_ctx.caseStudy.title)
                  ? (_openBlock(), _createBlock(_component_Editorial, { key: 0 }, {
                      default: _withCtx(() => [
                        _createElementVNode("h2", null, _toDisplayString(_ctx.caseStudy.title), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.challenge)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_AppButton, {
                      type: "outline",
                      padding: "narrow",
                      onClick: _ctx.showAddIdeaModal
                    }, {
                      iconBefore: _withCtx(() => [
                        _createVNode(_component_AddIcon, { class: "fill-current" })
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.caseStudy.focus_type)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_Editorial, null, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.caseStudy.focus_type, (type, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "inline-block text-sm py-1.5 px-2.5 rounded-lg mr-2 mb-1 bg-cebai-grey-lighter font-robotoMedium"
                      }, _toDisplayString(type), 1))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.caseStudy.challenge_area)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_Editorial, null, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.caseStudy.challenge_area, (area, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "inline-block text-sm py-1.5 px-2.5 rounded-lg mr-2 mb-1 bg-cebai-grey-lighter font-robotoMedium"
                      }, _toDisplayString(area), 1))
                    }), 128))
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_ContentBlockDivider),
            (_ctx.caseStudy.challenge)
              ? (_openBlock(), _createBlock(_component_Editorial, {
                  key: 2,
                  class: "mb-10"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createVNode(_component_Markdown, {
                      source: _ctx.caseStudy.challenge
                    }, null, 8, ["source"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.caseStudy.actions)
              ? (_openBlock(), _createBlock(_component_Editorial, {
                  key: 3,
                  class: "mb-10"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _createElementVNode("p", null, _toDisplayString(_ctx.caseStudy.actions), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.caseStudy.outcome)
              ? (_openBlock(), _createBlock(_component_Editorial, {
                  key: 4,
                  class: "mb-10"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createElementVNode("p", null, _toDisplayString(_ctx.caseStudy.outcome), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.caseStudy.different_action)
              ? (_openBlock(), _createBlock(_component_Editorial, {
                  key: 5,
                  class: "mb-10"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _createElementVNode("p", null, _toDisplayString(_ctx.caseStudy.different_action), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.caseStudy.tips)
              ? (_openBlock(), _createBlock(_component_Editorial, {
                  key: 6,
                  class: "mb-10"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13,
                    _createElementVNode("p", null, _toDisplayString(_ctx.caseStudy.tips), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isShown.addIdea,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isShown.addIdea) = $event)),
      close: () => _ctx.closeModal('addIdea')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalContent, {
          close: () => _ctx.closeModal('addIdea'),
          title: "Develop your idea"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_CreateIdea, {
              "close-modal": () => _ctx.closeModal('addIdea'),
              description: _ctx.caseStudy.description
            }, null, 8, ["close-modal", "description"])
          ]),
          _: 1
        }, 8, ["close"])
      ]),
      _: 1
    }, 8, ["modelValue", "close"])
  ], 64))
}